<template>
	<b-navbar>
		<template slot="brand">
			<b-navbar-item href="https://www.maptm.nl/">
                <img
                    src="@/assets/logo_map.svg"
                >
            </b-navbar-item>
        </template>

        <template v-if="!$isMobile()" slot="end">
            <b-navbar-item tag="div">
                <div class="buttons">
                    <b-button type="is-light" @click="changeManualModalState">
                        Manual
                    </b-button>
                    <b-button v-if="!signedIn" type="is-dark" @click="changeSignUpModalState">
                        <strong>Sign up</strong>
                    </b-button>
                    <b-button v-if="!signedIn" type="is-light" @click="changeLoginModalState">
                        Log in
                    </b-button>
                    <b-button v-if="signedIn" type="is-dark" @click="changeFeedbackModalState">
                        <strong>Feedback</strong>
                    </b-button>
                    <b-button v-if="signedIn" type="is-danger" @click="logOut">
                        <b-icon icon="power"></b-icon>
                    </b-button>
                </div>
            </b-navbar-item>
        </template>
    </b-navbar>
</template>


<script>
    import { Auth } from 'aws-amplify'
	export default {
		name: 'MaptmHeader',

        data() {
            return {
                isPublic: true
            }
        },

        computed: {
            signedIn () {
                return this.$store.state.signedIn;
            }
        },

		methods: {
            changeLoginModalState () {
                this.$store.commit('toggleLoginModal')
            },

            changeSignUpModalState () {
                this.$store.commit('toggleSignUpModal')
            },

            changeFeedbackModalState () {
                this.$store.commit('toggleFeedbackModal')
            },

            changeManualModalState () {
                this.$store.commit('toggleManualModal')
            },

            logOut () {
                Auth.signOut()
                .then(data => {
                    this.$store.state.signedIn = !!data;
                    this.$store.state.user = null
                })
                .catch(err => console.log(err));
            }
        }
	}
</script>

<style>
	nav.navbar {
		background-color: #6c757d;
	}
</style>